export const getPortalBrands = (API, request, callback) => {
    API.get(`brand`, { params: request }).then(response => {
        callback(response.data);
    }).catch(error => {
        console.log(error);
    });
}

export const onPortalBrands = (API, request, callback) => {
    API.delete(`brand/${request.id}`).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}

export const onPortalAddBrands = (API, request, callback) => {
    API.post(`brand`, request).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}

export const onPortalUpdateBrands = (API, request, callback) => {
    API.put(`brand/${request.id}`, request).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}